import convertVehicleToTcoVehicle from './convertVehicleToTcoVehicle';
import SetupEvaluation from './SetupEvaluation';
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState
  } from 'react';
import { TcoVehicleVM, VehicleEnhanced } from '@optimization/sa-common';
import { useExpandVehicleAndTab } from '../ExpandVehicleAndTabContext';
import { useParams } from 'react-router-dom';

interface FinancialEvaluation {
  startSetupEvaluation: (vehicle: VehicleEnhanced) => void;
}

const FinancialEvaluationContext = createContext<FinancialEvaluation | null>(null);

export const FinancialEvaluationProvider = ({ children }: { children: ReactNode }) => {
  const { solutionId } = useParams();
  const [vehicle, setVehicle] = useState<TcoVehicleVM | null>(null);

  const expandVehicleAndTab = useExpandVehicleAndTab();

  const expandVehicleAndTabCallback = useCallback(() => {
    if (expandVehicleAndTab) {
      expandVehicleAndTab.setExpandVehicleAndTab({ vehicleId: vehicle?.Id, candidateTab: 'Financial evaluation' });
    }
  }, [expandVehicleAndTab, vehicle?.Id]);

  const cancelSetupEvaluation = useCallback(() => {
    setVehicle(null);
    expandVehicleAndTabCallback();
  }, [expandVehicleAndTabCallback]);

  const startSetupEvaluation = useCallback((vehicleParam: VehicleEnhanced) => {
    const convertedVehicle = convertVehicleToTcoVehicle(vehicleParam);
    setVehicle(convertedVehicle);
  }, []);

  const setEvaluationIsDone = useCallback(() => {
    setVehicle(null);
    expandVehicleAndTabCallback();
  }, [expandVehicleAndTabCallback]);

  const value = useMemo(
    () => ({
      startSetupEvaluation,
    }),
    [startSetupEvaluation],
  );

  const vehicles = useMemo(() => (vehicle ? [vehicle] : null), [vehicle]);

  return (
    <FinancialEvaluationContext.Provider value={value}>
      {vehicles && solutionId ? (
        <div className="tds-container mt-spacing-96">
          <SetupEvaluation
            solutionId={solutionId}
            vehicles={vehicles}
            cancelSetupEvaluation={cancelSetupEvaluation}
            setEvaluationIsDone={setEvaluationIsDone}
          />
        </div>
      ) : (
        children
      )}
    </FinancialEvaluationContext.Provider>
  );
};

export const useFinancialEvaluation = () => useContext(FinancialEvaluationContext);
